import React from 'react';
import { graphql } from 'gatsby';
import { OmTabsProductCarousel } from '@om/component-library-react';
import RefinedProductCard from './RefinedProductCard'

function  createSlotName(index, tabNumber) {
    return `card-${index + 1}-tab-${tabNumber}`;
}
function createKey(tab, index) {
    return `tab_${tab}_card_${index}`;
}

const TabsProductCarousel = ({
    tabsProductCarouselContent,
    slot
}) => {
    if(!tabsProductCarouselContent) {
        return '';
    }

    const {
        use_heading_as_h1,
        is_extended,
        section_heading,
        section_caption,
        has_boundary,
        tab_text_one,
        tab_text_two,
        tab_text_three,
        tab_text_four,
        tab_text_five,
        tab_text_six,
        button_text,
        open_tab,
        is_extended_carousel,
        button_url,
        button_action_type,
        call_me_back,
        om_carousel_slot_one,
        om_carousel_slot_two,
        om_carousel_slot_three,
        om_carousel_slot_four,
        om_carousel_slot_five,
        om_carousel_slot_six
    } = tabsProductCarouselContent;

    return (
        <OmTabsProductCarousel
            slot={slot}
            hasBoundary={has_boundary}
            isExtended={is_extended ? is_extended : false}
            tabTextOne={tab_text_one ? tab_text_one : ''}
            tabTextTwo={tab_text_two ? tab_text_two : ''}
            tabTextThree={tab_text_three ? tab_text_three : ''}
            tabTextFour={tab_text_four ? tab_text_four : ''}
            tabTextFive={tab_text_five ? tab_text_five : ''}
            tabTextSix={tab_text_six ? tab_text_six : ''}
            callMeBackObject={call_me_back ? JSON.stringify(call_me_back) : ''}
            buttonText={button_text ? button_text : ''}
            buttonUrl={button_url ? button_url.href : ''}
            buttonActionType={button_action_type}
            openTab={open_tab}
            numberOfCardsTab1={om_carousel_slot_one ? om_carousel_slot_one.length : 0}
            numberOfCardsTab2={om_carousel_slot_two ? om_carousel_slot_two.length : 0}
            numberOfCardsTab3={om_carousel_slot_three ? om_carousel_slot_three.length : 0}
            numberOfCardsTab4={om_carousel_slot_four ? om_carousel_slot_four.length : 0}
            numberOfCardsTab5={om_carousel_slot_five ? om_carousel_slot_five.length : 0}
            numberOfCardsTab6={om_carousel_slot_six ? om_carousel_slot_six.length : 0}
            isExtendedCarousel={is_extended_carousel}
        >
            {
                use_heading_as_h1 ? <h1 slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} /> : <span slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} />
            }
            {
                section_caption ?  <span slot="section-caption" dangerouslySetInnerHTML={{__html: section_caption}} /> : ''
            }
            {/* <!-- Tab 1  --> */}
            {
                om_carousel_slot_one ? om_carousel_slot_one.map((card, index) => {
                    return (
                        <RefinedProductCard
                            refinedProductCardContent={card}
                            key={createKey(1, index)}
                            isLandscape={om_carousel_slot_one ? om_carousel_slot_one.length === 1 : false}
                            isExtended={is_extended_carousel}
                            slot={createSlotName(index, 1)}
                        /> )
                }) : ''
            }
            {/* //<!-- Tab 2 --> */}
            {
                om_carousel_slot_two ? om_carousel_slot_two.map((card, index) => {
                    return (
                        <RefinedProductCard
                            refinedProductCardContent={card}
                            key={createKey(2, index)}
                            isLandscape={om_carousel_slot_two ? om_carousel_slot_two.length === 1 : false}
                            isExtended={is_extended_carousel}
                            slot={createSlotName(index, 2)}
                        />
                    )
                }) : ''
            }
            {/* //<!-- Tab 3 --> */}
            {
                om_carousel_slot_three ? om_carousel_slot_three.map((card, index) => {
                    return (
                        <RefinedProductCard
                            refinedProductCardContent={card}
                            key={createKey(3, index)}
                            isLandscape={om_carousel_slot_three ? om_carousel_slot_three.length === 1 : false}
                            isExtended={is_extended_carousel}
                            slot={createSlotName(index, 3)}
                        />
                    )
                }) : ''
            }
            {/* //<!-- Tab 4 --> */}
            {
                om_carousel_slot_four ? om_carousel_slot_four.map((card, index) => {
                    return (
                        <RefinedProductCard
                            refinedProductCardContent={card}
                            key={createKey(4, index)}
                            isLandscape={om_carousel_slot_four ? om_carousel_slot_four.length === 1 : false}
                            isExtended={is_extended_carousel}
                            slot={createSlotName(index, 4)}
                        />
                    )

                }) : ''
            }
            {/* //<!-- Tab 5 --> */}
            {
                om_carousel_slot_five ? om_carousel_slot_five.map((card, index) => {
                    return (
                        <RefinedProductCard
                            refinedProductCardContent={card}
                            key={createKey(5, index)}
                            isLandscape={om_carousel_slot_five ? om_carousel_slot_five.length === 1 : false}
                            isExtended={is_extended_carousel}
                            slot={createSlotName(index, 5)}
                        />
                    )
                }) : ''
            }
            {/* //<!-- Tab 6 --> */}
            {
                om_carousel_slot_six ? om_carousel_slot_six.map((card, index) => {
                    return (
                        <RefinedProductCard
                            refinedProductCardContent={card}
                            key={createKey(6, index)}
                            isLandscape={om_carousel_slot_six ? om_carousel_slot_six.length === 1 : false}
                            isExtended={is_extended_carousel}
                            slot={createSlotName(index, 6)}
                        />
                    )
                }) : ''
            }
        </OmTabsProductCarousel>
    );
};

export const pageQuery = graphql`
fragment TabsProductCarousel on Contentstack_tabs_carousel_product {
    uid
    use_heading_as_h1
    is_extended
    section_heading
    section_caption
    has_boundary
    tab_text_one
    tab_text_two
    tab_text_three
    tab_text_four
    tab_text_five
    tab_text_six
    button_text
    open_tab
    is_extended_carousel
    button_url {
    	...Link
    }
    button_action_type
        call_me_back {
        ...CallMeBack
    }
    om_carousel_slot_one {
    	...RefinedProductCard
    }
    om_carousel_slot_two {
    	...RefinedProductCard
    }
    om_carousel_slot_three {
    	...RefinedProductCard
    }
    om_carousel_slot_four {
    	...RefinedProductCard
    }
    om_carousel_slot_five {
    	...RefinedProductCard
    }
    om_carousel_slot_six {
    	...RefinedProductCard
    }
}
`;

export default TabsProductCarousel